import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  chooseSituation: () => __(translations.commercialDocumentComponents.chooseSituation, 'Choose a situation'),
};
